import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import { authGuard } from "../auth/authGuard";

import DigitalPrintOrders from '@/components/DigitalPrintOrders.vue'
import LeisurewearUpdateNew from '@/components/LeisurewearUpdateNew.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    meta: {layout: "home"},
    component: Home,
    beforeEnter: authGuard
  },
  {
    path: '/about',
    name: 'About',
    meta: {layout: "sales"},
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  
  {
	path: '/orders',
    name: 'Orders',
    meta: {layout: "production"},
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "orders" */ '../components/Orders.vue'),
    beforeEnter: authGuard
  },
  {
    path: '/orders2',
      name: 'Orders2',
      meta: {layout: "sales"},
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "orders" */ '../components/Orders2.vue'),
      beforeEnter: authGuard
    },
    // PRINTED GARMENTS
   
    {
      path: '/digitalprint/dashboard',
        name: 'Digital Artwork Dashboard',
        meta: {layout: "digitalprint", screen: 'dashboard'},
        component: () => import(/* webpackChunkName: "digitalprint" */ '../components/DigitalPrint/Dashboard.vue'),
        beforeEnter: authGuard
      },
       {
      path: '/digitalprint/incoming-orders',
        name: 'Digital Artwork Incoming Orders',
        meta: {layout: "digitalprint", screen: 'incoming-orders'},
        component: () => import(/* webpackChunkName: "digitalprint" */ '../components/DigitalPrint/IncomingOrders.vue'),
        beforeEnter: authGuard
      },
      {
        path: '/digitalprint/new-artwork',
          name: 'New Artwork',
          meta: {layout: "digitalprint", screen: 'new-artwork'},
          component: () => import(/* webpackChunkName: "digitalprint" */ '../components/DigitalPrint/NewArtwork.vue'),
          beforeEnter: authGuard
        },
        {
          path: '/digitalprint/quality',
            name: 'Quality',
            meta: {layout: "digitalprint", screen: 'quality'},
            component: () => import(/* webpackChunkName: "digitalprint" */ '../components/DigitalPrint/Quality.vue'),
            beforeEnter: authGuard
          },
          {
            path: '/digitalprint/quality2',
              name: 'Quality2',
              meta: {layout: "digitalprint", screen: 'quality2'},
              component: () => import(/* webpackChunkName: "digitalprint" */ '../components/DigitalPrint/Quality2.vue'),
              beforeEnter: authGuard
            },
     
        {
          path: '/digitalprint/completed',
            name: 'Digital Print Completedd',
            meta: {layout: "digitalprint", screen: 'completed'},
            component: () => import(/* webpackChunkName: "vieworder" */ '../components/DigitalPrint/Completed.vue'),
            beforeEnter: authGuard
          },
        {
          path: '/digitalprint/view-order',
            name: 'Digital Print View Order',
            meta: {layout: "digitalprint", screen: 'makeup'},
            component: () => import(/* webpackChunkName: "vieworder" */ '../components/DigitalPrint/ViewOrder.vue'),
            beforeEnter: authGuard
          },
          {
            path: '/digitalprint/artwork-finished',
            name: 'ArtworkFinished',
            meta: {layout: "digitalprint"},
            component: () => import( '../components/DigitalPrint/ArtworkFinished.vue'),
            beforeEnter: authGuard
          } ,
          {
            path: '/digitalprint/qc-finished',
            name: 'QCFinished',
            meta: {layout: "digitalprint"},
            component: () => import( '../components/DigitalPrint/QCFinished.vue'),
            beforeEnter: authGuard
          } ,
          {
            path: '/digitalprint/scheduler',
            name: 'PrintScheduler',
            meta: {layout: "digitalprint"},
            component: () => import( '../components/DigitalPrint/Scheduler.vue'),
            beforeEnter: authGuard
          } ,
          {
            path: '/printing-cutting/scheduler',
            name: 'CuttingScheduler',
            meta: {layout: "printingcutting"},
            component: () => import( '../components/DigitalPrint/Scheduler.vue'),
            beforeEnter: authGuard
          } ,
          
          {
            path: '/printing-cutting/scheduler-2',
            name: 'CuttingScheduler2',
            meta: {layout: "printingcutting"},
            component: () => import( '../components/DigitalPrint/Scheduler.vue'),
            beforeEnter: authGuard
          } ,
          {
            path: '/digitalprint/repeat-artworks',
            name: 'RepeatArtworks',
            meta: {layout: "digitalprint"},
            component: () => import( '../components/DigitalPrint/RepeatArtworks.vue'),
            beforeEnter: authGuard
          } ,
          {
            path: '/orders/order-search/:id',
              name: 'Search Order',
              meta: {layout: "orders"},
              component: () => import(/* webpackChunkName: "searchorder" */ '../components/Orders/SearchOrder.vue'),
              beforeEnter: authGuard
            },
            {
              path: '/orders/order-search',
                name: 'Search Order',
                meta: {layout: "orders"},
                component: () => import(/* webpackChunkName: "searchorder" */ '../components/Orders/SearchOrder.vue'),
                beforeEnter: authGuard
              },
    {
      path: '/reports/early-orders',
      name: 'EarlyOrders',
      meta: {layout: "reports"},
      component: () => import( '../components/Reports/EarlyOrders.vue'),
      beforeEnter: authGuard
    } ,
    {
      path: '/reports/designs-uploaded',
      name: 'DesignsUploaded',
      meta: {layout: "reports"},
      component: () => import( '../components/Reports/DesignsUploaded.vue'),
      beforeEnter: authGuard
    } ,
    {
      path: '/reports/account-orders',
      name: 'AccountOrders',
      meta: {layout: "reports"},
      component: () => import( '../components/Reports/AccountOrders.vue'),
      beforeEnter: authGuard
    } ,
    {
      path: '/reports/orders-short-delivery',
      name: 'OrdersShortDelivery',
      meta: {layout: "reports"},
      component: () => import( '../components/Reports/OrdersShortDelivery.vue'),
      beforeEnter: authGuard
    } ,
    {
      path: '/reports/made-up-offshore',
      name: 'OrdersMadeUpOffshore',
      meta: {layout: "reports"},
      component: () => import( '../components/Reports/OrdersMadeUpOffshore.vue'),
      beforeEnter: authGuard
    } ,
    {
      path: '/reports/gaa-orders',
      name: 'GaaOrders',
      meta: {layout: "reports"},
      component: () => import( '../components/Reports/GaaOrders.vue'),
      beforeEnter: authGuard
    } ,
    {
      path: '/reports/orders-with-kids',
      name: 'OrdersWithKids',
      meta: {layout: "reports"},
      component: () => import( '../components/Reports/OrdersWithKids.vue'),
      beforeEnter: authGuard
    } ,
    {
      path: '/reports/knitted-trims',
      name: 'KnittedTrimsReport',
      meta: {layout: "knit"},
      component: () => import( '../components/Production/KnittedTrimsReport.vue'),
      beforeEnter: authGuard
    } ,
    {
      path: '/reports/ai/overview',
      name: 'EarlyOrders',
      meta: {layout: "home"},
      component: () => import( '../components/Reports/AI-Overview.vue'),
      beforeEnter: authGuard
    } ,
     {
      path: '/digitalprint-new',
        name: 'NewOrders',
        meta: {layout: "digitalprint", screen: 'new'},
        component: DigitalPrintOrders,
        beforeEnter: authGuard
      },
      {
        path: '/digitalprint-artwork',
          name: 'ArtworkOrders',
          meta: {layout: "digitalprint", screen: 'artwork'},
          component: DigitalPrintOrders,
          beforeEnter: authGuard
        },
        {
          path: '/digitalprint-print/:productionlocation',
            name: 'DigitalPrintPrint',
            meta: {layout: "digitalprint", screen: 'print'},
            component: DigitalPrintOrders,
            beforeEnter: authGuard
          } ,
          {
            path: '/digitalprint-application/:productionlocation',
              name: 'DigitalPrintApplication',
              meta: {layout: "digitalprint", screen: 'application'},
              component: DigitalPrintOrders,
              beforeEnter: authGuard
            } ,
          {
            path: '/digitalprint-cutting/:productionlocation',
              name: 'DigitalPrintCutting',
              meta: {layout: "digitalprint", screen: 'cutting'},
              component: DigitalPrintOrders,
              beforeEnter: authGuard
            } ,
            {
              path: '/digitalprint-makeup/:productionlocation',
                name: 'DigitalPrintMakeup',
                meta: {layout: "digitalprint", screen: 'makeup'},
                component: DigitalPrintOrders,
                beforeEnter: authGuard
              }, 
              
            {
      path: '/leisurewear/stock-new',
        name: 'LeisurewearStockNew',
        meta: {layout: "leisurewear"},
        component: () => import( '../components/Leisurewear/StockNew.vue'),
        beforeEnter: authGuard
      } ,
      {
        path: '/leisurewear-update-new',
          name: 'LeisurewearUpdateNew',
          meta: {layout: "leisurewear", screen: 'update'},
          component: LeisurewearUpdateNew,
          beforeEnter: authGuard
        },
        {
        path: '/sales/customer-orders',
        name: 'CustomerOrders',
        meta: {layout: "sales"},
        component: () => import( '../components/Sales/CustomerOrders.vue'),
        beforeEnter: authGuard
      } ,
      {
        path: '/sales/upload-design',
        name: 'UploadDesign',
        meta: {layout: "sales"},
        component: () => import( '../components/Sales/UploadDesign.vue'),
        beforeEnter: authGuard
      } ,
     
      // Screens for factory floor workers
      {
        path: '/printing-cutting/data-input',
          name: 'PrintingCuttingDataInput',
          meta: {layout: "input", screen: 'new'},
          component: () => import( '../components/PrintingCutting/DataInput.vue'),
          beforeEnter: authGuard
        },
        {
          path: '/printing-cutting/overview',
            name: 'PrintingCuttingOverview',
            meta: {layout: "printingcutting"},
            component: () => import( '../components/PrintingCutting/Overview.vue'),
            beforeEnter: authGuard
        },
        {
          path: '/printing-cutting/overviewreport',
            name: 'PrintingCuttingOverviewReport',
            meta: {layout: "printingcutting"},
            component: () => import( '../components/PrintingCutting/OverviewReport.vue'),
            beforeEnter: authGuard
        },
        {
          path: '/printing-cutting/planner',
            name: 'PrintPlanner',
            meta: {layout: "printingcutting"},
            component: () => import( '../components/PrintingCutting/PrintPlanner.vue'),
            beforeEnter: authGuard
        },
        {
          path: '/printing-cutting/printing-paper',
            name: 'PrintingPaper',
            meta: {layout: "printingcutting"},
            component: () => import(/* webpackChunkName: "printingcutting" */ '../components/PrintingCutting/PrintingPaper.vue'),
            beforeEnter: authGuard
          },
          {
            path: '/printing-cutting/printing-rolls',
              name: 'PrintingRolls',
              meta: {layout: "printingcutting"},
              component: () => import(/* webpackChunkName: "printingcutting" */ '../components/PrintingCutting/PrintingRolls.vue'),
              beforeEnter: authGuard
            },
    {
      path: '/printing-cutting/cutting',
        name: 'Digital Print Cutting',
        meta: {layout: "printingcutting"},
        component: () => import(/* webpackChunkName: "printingcutting" */ '../components/PrintingCutting/Cutting.vue'),
        beforeEnter: authGuard
      },
      {
        path: '/printing-cutting/multiply-cutting',
          name: 'Multiply Cutting',
          meta: {layout: "printingcutting", location: ''},
          component: () => import(/* webpackChunkName: "printingcutting" */ '../components/PrintingCutting/MultiplyCutting.vue'),
          beforeEnter: authGuard
        },
        {
          path: '/offshore-print/multiply-cutting',
            name: 'Multiply Cutting',
            meta: {layout: "offshoreprintingcutting", location: 'offshore'},
            component: () => import(/* webpackChunkName: "printingcutting" */ '../components/PrintingCutting/MultiplyCutting.vue'),
            beforeEnter: authGuard
          },
        
      {
        path: '/printing-cutting/awaiting-makeup',
          name: 'Digital Print Awaiting Makeup',
          meta: {layout: "printingcutting"},
          component: () => import(/* webpackChunkName: "printingcutting" */ '../components/PrintingCutting/AwaitingMakeup.vue'),
          beforeEnter: authGuard
        },
        {
          path: '/printing-cutting/multiply-awaiting-makeup',
            name: 'Multiply Awaiting Makeup',
            meta: {layout: "printingcutting"},
            component: () => import(/* webpackChunkName: "printingcutting" */ '../components/PrintingCutting/MultiplyAwaitingMakeup.vue'),
            beforeEnter: authGuard
          },
        {
          path: '/printing-cutting/view-order/:id',
            name: 'DigitalPrintViewOrderById',
            meta: {layout: "printingcutting"},
            component: () => import(/* webpackChunkName: "printingcutting" */ '../components/PrintingCutting/ViewOrder.vue'),
            beforeEnter: authGuard
          },
        {
        path: '/printing-cutting/view-order',
          name: 'DigitalPrintViewOrder',
          meta: {layout: "printingcutting"},
          component: () => import(/* webpackChunkName: "printingcutting" */ '../components/PrintingCutting/ViewOrder.vue'),
          beforeEnter: authGuard
        },
        {
          path: '/reports/printing-cutting-summary',
          name: 'PrintingCuttingSummaryReport',
          meta: {layout: "printingcutting"},
          component: () => import( '../components/Reports/PrintingCuttingSummary.vue'),
          beforeEnter: authGuard
        } ,
        {
          path: '/reports/printing-processed-report',
          name: 'PrintingProcessedReport',
          meta: {layout: "printingcutting"},
          component: () => import( '../components/Reports/PrintingProcessedReport.vue'),
          beforeEnter: authGuard
        } ,
        {
          path: '/reports/bundle-summary',
          name: 'BundleSummaryReport',
          meta: {layout: "makeup"},
          component: () => import( '../components/Reports/BundleSummary.vue'),
          beforeEnter: authGuard
        } ,
        {
          path: '/printing-cutting/silicon-stripes',
            name: 'SiliconStripes',
            meta: {layout: "input", screen: 'new'},
            component: () => import( '../components/PrintingCutting/SiliconStripes.vue'),
            beforeEnter: authGuard
          },
        {
          path: '/printing-cutting/bundling/:id',
            name: 'Bundling',
            meta: {layout: "printingcutting"},
            component: () => import( '../components/PrintingCutting/Bundling.vue'),
            beforeEnter: authGuard
        },
        {
          path: '/printing-cutting/bundling-barcodes/:id',
            name: 'BundlingBarcodes',
            meta: {layout: "blank", screen: 'new'},
            component: () => import( '../components/PrintingCutting/BundlingBarcodes.vue'),
            beforeEnter: authGuard
        },
        {
          path: '/makeup/overview',
            name: 'MakeupOverview',
            meta: {layout: "makeup"},
            component: () => import( '../components/Makeup/Overview.vue'),
            beforeEnter: authGuard
        },
        {
          path: '/makeup/work-in-progress',
            name: 'MakeupWorkInProgress',
            meta: {layout: "makeup"},
            component: () => import( '../components/Makeup/WorkInProgress.vue'),
            beforeEnter: authGuard
        },
        {
          path: '/makeup/to-be-completed',
            name: 'MakeupToBeCompleted',
            meta: {layout: "makeup"},
            component: () => import( '../components/Makeup/ToBeCompleted.vue'),
            beforeEnter: authGuard
        },
        {
          path: '/makeup/productivity-scanning',
            name: 'ProductivityScanning',
            meta: {layout: "makeup"},
            component: () => import( '../components/Makeup/ProductivityScanning.vue'),
            beforeEnter: authGuard
        },
        {
          path: '/makeup/productivity-reporting',
            name: 'ProductivityReporting',
            meta: {layout: "makeup"},
            component: () => import( '../components/Makeup/ProductivityReporting.vue'),
            beforeEnter: authGuard
        },
        {
          path: '/makeup/data-input',
            name: 'MakeupDataInput',
            meta: {layout: "input", screen: 'new'},
            component: () => import( '../components/Makeup/DataInput.vue'),
            beforeEnter: authGuard
        },
        {
          path: '/makeup/data-input-offshore',
            name: 'MakeupDataInputOffShore',
            meta: {layout: "input", screen: 'new'},
            component: () => import( '../components/Makeup/DataInputOffShore.vue'),
            beforeEnter: authGuard
        },
        {
          path: '/makeup/view-order',
            name: 'Makeup View Order',
            meta: {layout: "makeup"},
            component: () => import(/* webpackChunkName: "vieworder" */ '../components/PrintingCutting/ViewOrder.vue'),
            beforeEnter: authGuard
          },
    {
      path: '/production/garment-admin',
        name: 'GarmentAdmin',
        meta: {layout: "production"},
        component: () => import( '../components/Production/GarmentAdmin.vue'),
        beforeEnter: authGuard
    },
    {
      path: '/garments',
        name: 'ListGarments',
        meta: {layout: "production"},
        component: () => import( '../components/Production/ListGarments.vue'),
        beforeEnter: authGuard
    },
    {
      path: '/production/trexcode-admin',
        name: 'TrexCodeAdmin',
        meta: {layout: "production"},
        component: () => import( '../components/Production/TrexCodeAdmin.vue'),
        beforeEnter: authGuard
    },
    {
      path: '/production/hist-lw-orders',
        name: 'Hist LW Orders',
        meta: {layout: "production"},
        component: () => import( '../components/Production/HistLwOrders.vue'),
        beforeEnter: authGuard
    },
          /*{
            path: '/production/open-orders',
              name: 'OpenOrders',
              meta: {layout: "production"},
              component: () => import( '../components/Production/OpenOrders.vue'),
              beforeEnter: authGuard
          }, Old report now using locations*/
          {
            path: '/production/open-orders-2',
              name: 'OpenOrders2',
              meta: {layout: "production"},
              component: () => import( '../components/Production/OpenOrders2.vue'),
              beforeEnter: authGuard
          },
          {
            path: '/production/open-orders-pat',
              name: 'OpenOrdersPat',
              meta: {layout: "production"},
              component: () => import( '../components/Production/OpenOrdersPat.vue'),
              beforeEnter: authGuard
          },
          {
            path: '/production/open-orders-tony',
              name: 'OpenOrdersPat',
              meta: {layout: "production"},
              component: () => import( '../components/Production/OpenOrdersTony.vue'),
              beforeEnter: authGuard
          },
           {
            path: '/production/open-orders-aggregated',
              name: 'OpenOrders2',
              meta: {layout: "production"},
              component: () => import( '../components/Production/OpenOrdersAggregated.vue'),
              beforeEnter: authGuard
          },
    {
      path: '/production/incoming-orders',
        name: 'ProductionIncoming',
        meta: {layout: "production"},
        component: () => import( '../components/Production/IncomingOrders.vue'),
        beforeEnter: authGuard
    },
    {
      path: '/production/makeup-allocated',
        name: 'MakeupAllocated',
        meta: {layout: "production"},
        component: () => import( '../components/Production/MakeupAllocated.vue'),
        beforeEnter: authGuard
    },
    {
      path: '/production/export-scheduler',
        name: 'MakeupAllocated',
        meta: {layout: "production"},
        component: () => import( '../components/Production/ExportScheduler.vue'),
        beforeEnter: authGuard
    },
    {
      path: '/production/export-planner',
        name: 'ExportToPlanner',
        meta: {layout: "production"},
        component: () => import( '../components/Production/ExportPlanner.vue'),
        beforeEnter: authGuard
    },
    {
      path: '/cut-sew/incoming-orders',
        name: 'CutSewIncoming',
        meta: {layout: "cutsew"},
        component: () => import( '../components/CutSew/IncomingOrders.vue'),
        beforeEnter: authGuard
    },
    {
      path: '/cut-sew/cutting-overview',
        name: 'CuttingOverview',
        meta: {layout: "cutsew"},
        component: () => import( '../components/CutSew/CuttingOverview.vue'),
        beforeEnter: authGuard
    },
    {
      path: '/cut-sew/warehouse',
        name: 'CutSewWarehouse',
        meta: {layout: "cutsew"},
        component: () => import( '../components/CutSew/Warehouse.vue'),
        beforeEnter: authGuard
    },
    /*{
      path: '/cut-sew/makeup-overview',
        name: 'MakeupOverview',
        meta: {layout: "cutsew"},
        component: () => import( '../components/CutSew/MakeupOverview.vue'),
        beforeEnter: authGuard
    },
    {
      path: '/cut-sew/makeup-complete',
        name: 'MakeupComplete',
        meta: {layout: "cutsew"},
        component: () => import( '../components/CutSew/MakeupComplete.vue'),
        beforeEnter: authGuard
    },*/
    {
      path: '/cut-sew/data-input',
        name: 'CutSewDataInput',
        meta: {layout: "input", screen: 'new'},
        component: () => import( '../components/CutSew/DataInput.vue'),
        beforeEnter: authGuard
    },
    {
      path: '/cut-sew/export-pms',
        name: 'ExportPms',
        meta: {layout: "cutsew"},
        component: () => import( '../components/CutSew/ExportPms.vue'),
        beforeEnter: authGuard
    },
    {
      path: '/cut-sew/cutting-planner',
        name: 'CuttingPlanner',
        meta: {layout: "cutsew"},
        component: () => import( '../components/CutSew/CuttingPlanner.vue'),
        beforeEnter: authGuard
    },
    {
      path: '/cut-sew/cutting-report',
        name: 'CuttingReport',
        meta: {layout: "cutsew"},
        component: () => import( '../components/CutSew/CuttingReport.vue'),
        beforeEnter: authGuard
    },
    {
      path: '/strabane/strabane-incoming-orders',
        name: 'StrabaneIncoming',
        meta: {layout: "strabane"},
        component: () => import( '../components/Strabane/StrabaneIncomingOrders.vue'),
        beforeEnter: authGuard
    },
    {
      path: '/offshore/embroidery-incoming',
        name: 'OffshoreEmbroideryIncoming',
        meta: {layout: "offshore"},
        component: () => import( '../components/Offshore/EmbroideryIncoming.vue'),
        beforeEnter: authGuard
    },
    {
      path: '/offshore/embroidery-inprogress',
        name: 'OffshoreEmbroideryInProgress',
        meta: {layout: "offshore"},
        component: () => import( '../components/Offshore/EmbroideryInProgress.vue'),
        beforeEnter: authGuard
    }, {
      path: '/offshore/embroidery-strabane',
        name: 'OffshoreEmbroideryStrabane',
        meta: {layout: "offshore"},
        component: () => import( '../components/Offshore/EmbroideryStrabane.vue'),
        beforeEnter: authGuard
    },
    {
      path: '/offshore/embroidery-report',
        name: 'OffshoreEmbroideryReport',
        meta: {layout: "offshore"},
        component: () => import( '../components/Offshore/EmbroideryReport.vue'),
        beforeEnter: authGuard
    },
    {
      path: '/production/knitted-trims',
        name: 'KnittedTrims',
        meta: {layout: "knit"},
        component: () => import( '../components/Production/KnittedTrims.vue'),
        beforeEnter: authGuard
    },
     {
      path: '/production/hats-incoming',
        name: 'HatsIncoming',
        meta: {layout: "knit"},
        component: () => import( '../components/Production/HatsIncoming.vue'),
        beforeEnter: authGuard
    },
    {
      path: '/production/hats-inprogress',
        name: 'HatsInProgress',
        meta: {layout: "knit"},
        component: () => import( '../components/Production/HatsInProgress.vue'),
        beforeEnter: authGuard
    },
    {
      path: '/production/hats-completed',
        name: 'HatsCompleted',
        meta: {layout: "knit"},
        component: () => import( '../components/Production/HatsCompleted.vue'),
        beforeEnter: authGuard
    },
    {
      path: '/offshore/orders',
        name: 'OffshoreOrders',
        meta: {layout: "home"},
        component: () => import( '../components/Offshore/AllOrders.vue'),
        beforeEnter: authGuard
    },
    {
      path: '/offshore/makeup',
        name: 'OffshoreMakeup',
        meta: {layout: "home"},
        component: () => import( '../components/Offshore/Makeup.vue'),
        beforeEnter: authGuard
    },
    {
      path: '/offshore/summary-report',
        name: 'OffshoreSummaryReport',
        meta: {layout: "home"},
        component: () => import( '../components/Offshore/SummaryReport.vue'),
        beforeEnter: authGuard
    },
    {
      path: '/offshore/planner',
        name: 'OffshorePrintPlanner',
        meta: {layout: "offshoreprintingcutting"},
        component: () => import( '../components/PrintingCutting/PrintPlanner.vue'),
        beforeEnter: authGuard
    },
    {
      path: '/finance/internal-orders',
        name: 'List Internal Orders',
        meta: {layout: "finance"},
        component: () => import(/* webpackChunkName: "finance" */ '../components/Finance/ListInternalOrders.vue'),
        beforeEnter: authGuard
      },
      {
        path: '/finance/add-internal-order',
          name: 'Add Internal Order',
          meta: {layout: "finance"},
          component: () => import(/* webpackChunkName: "finance" */ '../components/Finance/AddInternalOrder.vue'),
          beforeEnter: authGuard
        },
        {
          path: '/finance/internal-order/:id',
            name: 'View Internal Order',
            meta: {layout: "finance"},
            component: () => import(/* webpackChunkName: "finance" */ '../components/Finance/ViewInternalOrder.vue'),
            beforeEnter: authGuard
          },
    {
            path: '/finance/dublin-internal-report',
              name: 'Dublin Internal Report',
              meta: {layout: "finance"},
              component: () => import(/* webpackChunkName: "finance" */ '../components/Finance/DublinInternalReport.vue'),
              beforeEnter: authGuard
    },
    
    {
      path: '/samples/list-samples/new',
        name: 'New Samples',
        meta: {layout: "samples"},
        component: () => import(/* webpackChunkName: "samples" */ '../components/Samples/ListSamples.vue'),
        beforeEnter: authGuard
    },
     {
      path: '/samples/list-samples/inprogress',
        name: 'In Progress Samples',
        meta: {layout: "samples"},
        component: () => import(/* webpackChunkName: "samples" */ '../components/Samples/ListSamples.vue'),
        beforeEnter: authGuard
    },
    {
      path: '/samples/list-samples/mysamples',
        name: 'ListSamplesMine',
        meta: {layout: "samples"},
        component: () => import(/* webpackChunkName: "samples" */ '../components/Samples/ListSamplesArea.vue'),
        beforeEnter: authGuard
    },
    {
      path: '/samples/list-samples/artwork',
        name: 'ListSamplesArtwork',
        meta: {layout: "samples"},
        component: () => import(/* webpackChunkName: "samples" */ '../components/Samples/ListSamplesArea.vue'),
        beforeEnter: authGuard
    },
    {
      path: '/samples/list-samples/digital-print',
        name: 'ListSamplesDigitalPrint',
        meta: {layout: "samples"},
        component: () => import(/* webpackChunkName: "samples" */ '../components/Samples/ListSamplesArea.vue'),
        beforeEnter: authGuard
    },
    {
      path: '/samples/list-samples/makeup',
        name: 'ListSamplesMakeup',
        meta: {layout: "samples"},
        component: () => import(/* webpackChunkName: "samples" */ '../components/Samples/ListSamplesArea.vue'),
        beforeEnter: authGuard
    },
    {
      path: '/samples/list-samples-production',
        name: 'ListSamplesProduction',
        meta: {layout: "samples"},
        component: () => import(/* webpackChunkName: "samples" */ '../components/Samples/ListSamplesProduction.vue'),
        beforeEnter: authGuard
    },
    {
      path: '/samples/list-samples-makeup',
        name: 'ListSamplesMakeup',
        meta: {layout: "samples"},
        component: () => import(/* webpackChunkName: "samples" */ '../components/Samples/ListSamplesMakeup.vue'),
        beforeEnter: authGuard
    },
    {
      path: '/samples/new-request',
        name: 'New Request',
        meta: {layout: "samples"},
        component: () => import(/* webpackChunkName: "samples" */ '../components/Samples/NewRequest.vue'),
        beforeEnter: authGuard
    },
    {
      path: '/samples/edit-request',
        name: 'Edit Request',
        meta: {layout: "samples"},
        component: () => import(/* webpackChunkName: "samples" */ '../components/Samples/EditRequest.vue'),
        beforeEnter: authGuard
    },
    {
      path: '/samples/data-input',
        name: 'SamplesDataInput',
        meta: {layout: "samples"},
        component: () => import(/* webpackChunkName: "samples" */ '../components/Samples/DataInput.vue'),
        beforeEnter: authGuard
    },
    {
      path: '/samples/view/:id',
        name: 'View Request',
        meta: {layout: "samples"},
        component: () => import(/* webpackChunkName: "samples" */ '../components/Samples/ViewRequest.vue'),
        beforeEnter: authGuard
    },
    // Offshore Printing
    {
      path: '/offshore-print/overview',
        name: 'OffshorePrintingCuttingOverview',
        meta: {layout: "offshoreprintingcutting"},
        component: () => import( '../components/PrintingCutting/Overview.vue'),
        beforeEnter: authGuard
    },
    {
      path: '/offshore-print/printing-paper',
        name: 'OffshorePrintingPaper',
        meta: {layout: "offshoreprintingcutting"},
        component: () => import(/* webpackChunkName: "printingcutting" */ '../components/PrintingCutting/PrintingPaper.vue'),
        beforeEnter: authGuard
      },
      {
        path: '/offshore-print/printing-rolls',
          name: 'OffshorePrintingRolls',
          meta: {layout: "offshoreprintingcutting"},
          component: () => import(/* webpackChunkName: "printingcutting" */ '../components/PrintingCutting/PrintingRolls.vue'),
          beforeEnter: authGuard
        },
{
  path: '/offshore-print/cutting',
    name: 'Offshore Digital Print Cutting',
    meta: {layout: "offshoreprintingcutting"},
    component: () => import(/* webpackChunkName: "printingcutting" */ '../components/PrintingCutting/Cutting.vue'),
    beforeEnter: authGuard
  },
 
  {
    path: '/offshore-print/awaiting-makeup',
      name: 'Offshore Digital Print Awaiting Makeup',
      meta: {layout: "offshoreprintingcutting"},
      component: () => import(/* webpackChunkName: "printingcutting" */ '../components/PrintingCutting/AwaitingMakeup.vue'),
      beforeEnter: authGuard
    },
    {
      path: '/offshore-print/printing-cutting-summary',
      name: 'OffshorePrintingCuttingSummaryReport',
      meta: {layout: "offshoreprintingcutting"},
      component: () => import( '../components/Reports/PrintingCuttingSummary.vue'),
      beforeEnter: authGuard
    } ,
    {
      path: '/offshore-print/printing-processed-report',
      name: 'OffshorePrintingProcessedReport',
      meta: {layout: "offshoreprintingcutting"},
      component: () => import( '../components/Reports/PrintingProcessedReport.vue'),
      beforeEnter: authGuard
    } ,
    {
      path: '/todoist',
      name: 'Todoist',
      meta: {layout: "blank"},
      component: () => import( '../components/Generic/Todoist.vue'),
      beforeEnter: authGuard
    } ,
        
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
